import { Link } from "react-router-dom";
import { Badge, money } from "@/components/auction/AuctionUI";

export const ORDER_STAGE = {
  PENDIENTE_PAGO: ["Esperando pago", "amber"],
  PAGO_POR_VERIFICAR: ["Pago por verificar", "amber"],
  PAGADO: ["Pagada · por enviar", "coral"],
  ENVIADO: ["Enviada · en camino", "amber"],
  PENDIENTE_LIBERACION: ["Entregada · por liberar", "green"],
  LIBERADO: ["Liberada · ciclo cerrado", "green"],
  EN_DISPUTA: ["En disputa", "coral"],
  CANCELADO: ["Cancelada", "gray"],
  RECHAZADO: ["Pago rechazado", "gray"],
  REEMBOLSADO: ["Reembolsada", "gray"],
};

const STEPS = ["PENDIENTE_PAGO", "PAGADO", "ENVIADO", "PENDIENTE_LIBERACION", "LIBERADO"];
const STEP_LABEL = ["Pago", "Envío", "Entrega", "Liberación", "Cerrado"];

export function OrderStageBadge({ order, testid }) {
  const [label, tone] = ORDER_STAGE[order.status] || [order.status, "gray"];
  return <Badge tone={tone} testid={testid}>{label}</Badge>;
}

export function OrderSteps({ status, testid }) {
  const i = STEPS.indexOf(status === "PAGO_POR_VERIFICAR" ? "PENDIENTE_PAGO" : status);
  if (i < 0) return null;
  return (
    <div className="flex items-center gap-1 mt-2" data-testid={testid}>
      {STEP_LABEL.map((l, k) => (
        <div key={l} className="flex-1 min-w-0">
          <div className={`h-1 rounded-full ${k <= i ? "bg-[#34D399]" : "bg-white/10"}`} />
          <div className={`sx-mono text-[9px] mt-1 truncate ${k <= i ? "text-white/70" : "text-white/30"}`}>{l}</div>
        </div>
      ))}
    </div>
  );
}

// role: "seller" | "buyer"
export function OrderAction({ order, auctionId, offer, role }) {
  const st = order?.status;
  const orderLabel = role === "seller" ? "Ver pedido · contactar comprador" : "Ver pedido · contactar vendedor";
  let to = order ? `/order/${order.id}` : null, label = orderLabel, primary = false;
  if (role === "buyer" && offer && !offer.accepted) { to = `/subastas/pagar/${auctionId}`; label = "Aceptar oferta"; primary = true; }
  else if (role === "buyer" && (!order || st === "PENDIENTE_PAGO")) { to = `/subastas/pagar/${auctionId}`; label = `Pagar ${offer?.amount != null ? money(offer.amount) : ""}`; primary = true; }
  else if (role === "buyer" && st === "ENVIADO") { label = "Confirmar que la recibí"; primary = true; }
  else if (role === "seller" && st === "PAGADO") { label = "Marcar como enviada"; primary = true; }
  if (!to) return null;
  const secondary = order && (to !== `/order/${order.id}` || label !== orderLabel) ? (
    <Link to={`/order/${order.id}`} data-testid={`order-contact-${role}-${auctionId}`}
          className="sx-btn-ghost h-10 px-5 inline-flex items-center justify-center text-sm whitespace-nowrap">{orderLabel}</Link>
  ) : null;
  return (
    <div className="flex flex-wrap gap-2">
    {secondary}
    <Link to={to} data-testid={`order-action-${role}-${auctionId}`}
          className={`${primary ? "sx-btn" : "sx-btn-ghost"} h-10 px-5 inline-flex items-center justify-center text-sm whitespace-nowrap`}>
      {label}
    </Link>
    </div>
  );
}
